import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { SchemeService } from '../../../services/scheme.service';
import { ApiService } from '../../../services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';

interface TeamMember {
  // id: number;
  // name: string;
  // role: string;
  // designation: string;
  // avatar?: string;
}

@Component({
  selector: 'app-propogal-dashboard',
  standalone: false,
  templateUrl: './propogal-dashboard.component.html',
  styleUrl: './propogal-dashboard.component.scss'
})
export class PropogalDashboardComponent implements OnInit {
  proposal: any
  projectTitle: string = '';
  projectDescription: string = 'Procurement process for specialized technical equipment under the defense modernization initiative.';
  status: string = '';
  timeline: string = 'Oct 10, 2023 - Dec 15, 2023';
  budget: number = 2500000;
  progress: number = 65;

  projectDetails = {
    startDate: 'Oct 10, 2023',
    dueDate: 'Dec 15, 2023',
    category: 'Defense',
    priority: 'High',
    stages: 5,
    documents: 3
  };

  teamMembers = [
    // {
    //   id: 1,
    //   name: 'John Doe',
    //   role: 'DOI',
    //   designation: 'DOI',
    //   avatar: 'assets/avatars/avatar1.jpg'
    // },
    // {
    //   id: 2,
    //   name: 'Jane Smith',
    //   role: 'PROF DTES',
    //   designation: 'PROF DTES',
    //   avatar: 'assets/avatars/avatar2.jpg'
    // },
    // {
    //   id: 3,
    //   name: 'Alex Johnson',
    //   role: 'USER DTES',
    //   designation: 'USER DTES',
    //   avatar: 'assets/avatars/avatar3.jpg'
    // },
    // {
    //   id: 4,
    //   name: 'Sarah Williams',
    //   role: 'IFA REP',
    //   designation: 'IFA REP',
    //   avatar: 'assets/avatars/avatar4.jpg'
    // }
  ];
  visible: boolean = false;
  routeForm: FormGroup;
  steps: any;
  cols: any[] = [
    { field: 'user.first_name', header: 'First Name', filterType: 'text' },
    { field: 'user.last_name', header: 'Last Name', filterType: 'text' },
    { field: 'proposal_step.name', header: 'Proposal Step Name', filterType: 'text' },
    { field: 'role.name', header: 'Role', filterType: 'text' },

  ];
  stagesList: any[] = []
  phases: any;
  activePhaseId: any;
  currentPhase: any
  constructor(private schemeService: SchemeService, private api: ApiService, private messageService: MessageService, private fb: FormBuilder, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.phases = this.schemeService.getPhases();
    this.route.queryParams.subscribe(params => {
      const proposalId = params['id'];
      const phaseId = params['phase']
      this.activePhaseId = phaseId
      if (proposalId) {
        this.fetchProposalById(proposalId);  // Fetch full proposal from backend
      }
      if (this.phases && this.phases.length > 0) {
        const foundPhase = this.phases.find(phase => phase.id == this.activePhaseId);
        this.currentPhase = foundPhase ? foundPhase.name : 'Unknown Phase';
      }
    });
    this.routeForm = this.fb.group({
      step: ['', Validators.required],
      role: ['', Validators.required],
      user: ['', Validators.required],
      level: ['', Validators.required],
      approved: [false, Validators.required]
    })
  }
  fetchProposalById(id: number) {
    this.schemeService.getProposalById(id).subscribe(
      (data) => {
        this.proposal = data;
        this.getProposalWorkflow(); // Now safe to call
      },
      (error) => {
        console.error('Failed to load proposal:', error);
      }
    );
  }

  onApproveStage() {
    // Implement stage approval logic
  }

  onManageTeam() {
    // Implement team management logic
    this.visible = true;
    this.getRoleList();
    this.getUserList();
    this.getSteps();
    // this.getProposalWorkflow();
    this.api.getAPI(`/transaction/proposals/${this.proposal.id}/steps/?skipped=False`).subscribe((res: any) => {
      this.stagesList = res
      // this.routeForm.get('step')?.setValue(this.stagesList[0].id);
      this.getProposalWorkflow();
    });
  }
  getProposalWorkflow() {
    this.api.getAPI(`/transaction/proposal-workflow/?proposal_step__proposal=${this.proposal.id}`).subscribe((res: any) => {
      this.teamMembers = res.data || []
      this.groupTeamMembersByUser();
    });
  }
  groupedTeamMembers: any[] = [];

  groupTeamMembersByUser() {
    const userMap = new Map();

    for (const member of this.teamMembers) {
      const userId = member.user?.id;

      if (!userMap.has(userId)) {
        userMap.set(userId, {
          user: member.user,
          roles: new Map()
        });
      }

      const userEntry = userMap.get(userId);
      const roleName = member.role?.name;

      if (!userEntry.roles.has(roleName)) {
        userEntry.roles.set(roleName, []);
      }

      userEntry.roles.get(roleName).push(member.proposal_step.name);
    }

    this.groupedTeamMembers = Array.from(userMap.values()).map(entry => {
      return {
        user: entry.user,
        roles: Array.from(entry.roles.entries()).map(([role, steps]) => ({
          role,
          steps
        }))
      };
    });
  }

  proposalData: any;
  onrouteFormSubmit() {
    if (this.routeForm.invalid) return;

    const formValue = this.routeForm.value;

    const payload = {
      status: 1,
      sequence: +formValue.level, // Convert level input to number
      proposal_step: formValue.step,
      user: formValue.user,
      role: formValue.role,
      is_final_approve: formValue.approved
    };
    if (!payload.is_final_approve) {
      payload.role = this.routeForm.get('role')?.value;
    } else {
      payload.role = 1;
    }
    this.api.postAPI(`/transaction/proposal-workflow/`, payload).subscribe({
      next: (res: any) => {
        // this.proposalData = res;

        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: 'Proposal added successfully.',
        // });
        this.api.getAPI(`/transaction/proposal-workflow?proposal_step_id=${formValue.step}`).subscribe((res: any) => {
          this.proposalData = res

        });
        this.routeForm.reset();
        // this.addProposalVisible = false;
      },
      error: (err) => {
        console.error('Update failed:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: err?.error?.detail || 'Something went wrong while updating the mapping.',
        // });
      }
    });
  }
  roleList = []
  userList = []
  getRoleList() {
    this.api.getAPI('/access/user-roles/').subscribe((res: any) => {
      let resp = res.data
      this.roleList = res || resp.data;
    })
  }
  getUserList() {
    this.api.getAPI('/account/users/').subscribe((res: any) => {
      this.userList = res.data;
    })
  }

  getSteps() {
    this.api.getAPI(`/transaction/proposals/${this.proposal.id}/steps/`).subscribe(res => {
      this.steps = res;

    })
  }
  onStepChange(event: any) {
    const selectedStepId = event.value;
    this.api.getAPI(`/transaction/proposal-workflow?proposal_step_id=${selectedStepId}`).subscribe((res: any) => {
      this.proposalData = res

    });
  }
  myResources = [
    { id: 1, name: 'Alice', title: 'Developer' },
    { id: 2, name: 'Bob', title: 'Designer' }
  ];

  myEvents = [
    { id: 1, resourceId: 1, title: 'Task A', progress: 40, color: '#ff9f89', start: '2025-06-10', end: '2025-06-12' },
    { id: 2, resourceId: 2, title: 'Task B', progress: 70, color: '#6ec1e4', start: '2025-06-11', end: '2025-06-13' }
  ];

  showPopup = false;
  popupEvent: any = {};

  getEventsByResource(resourceId: number) {
    return this.myEvents.filter(e => e.resourceId === resourceId);
  }

  openPopup(event: any) {
    this.popupEvent = { ...event }; // Clone for editing
    this.showPopup = true;
  }

  closePopup() {
    this.showPopup = false;
  }

  saveEvent() {
    const index = this.myEvents.findIndex(e => e.id === this.popupEvent.id);
    if (index > -1) {
      this.myEvents[index] = { ...this.popupEvent };
    }
    this.closePopup();
  }
  openFullscreen = false
  totalTimline: any
  onStepsReceived(stepsData: any) {
    // this.steps = stepsData;
    this.progress = stepsData.percentage
    this.projectDetails.stages = stepsData.total_steps
    this.totalTimline = stepsData.weekly_timeline
  }
  getUniqueTeamMembers() {
  // Create a map to store unique users by ID
  const uniqueMembers = new Map<number, any>();
  
  // Iterate through team members and add to map if not already present
  this.teamMembers.forEach(member => {
    if (!uniqueMembers.has(member.user?.id)) {
      uniqueMembers.set(member.user?.id, member);
    }
  });
  
  // Convert map values back to array and slice first 4
  return Array.from(uniqueMembers.values()).slice(0, 4);
}
stringToColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash % 360);
  return `hsl(${hue}, 60%, 85%)`;
}
getProgressColor(progress: number): string {
  if (progress < 30) return '#e74c3c';  // Red
  if (progress < 70) return '#f39c12';  // Orange
  return '#2ecc71';  // Green
}
}
